// extracted by mini-css-extract-plugin
module.exports = {"ContactInformation":"_3b26taDa","icon":"_35B6ovtK","label":"_2SYkPGis","description":"_1tzPHtWn","link":"v0UygjEF"};